__turbopack_context__.v({
  "address": "Retailer-module__sOa9ia__address",
  "contact": "Retailer-module__sOa9ia__contact",
  "info": "Retailer-module__sOa9ia__info",
  "name": "Retailer-module__sOa9ia__name",
  "popup": "Retailer-module__sOa9ia__popup",
  "root": "Retailer-module__sOa9ia__root",
});
